import React from 'react'
import Serviceheader from './Serviceheader'
import Servicesdetails from './Servicesdetails'

const Services = () => {
  return (
    <div>
      <Serviceheader/>
      <Servicesdetails/>
    </div>
  )
}

export default Services